module.exports = __webpack_public_path__ + "img/lkqrcode.362936df.png";